import React, {useEffect, useState} from 'react';
import {Button, Col, Modal, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEraser, faPlus} from "@fortawesome/free-solid-svg-icons";
import '../../Styles/Taetigkeitsbericht/taetigkeitsbericht.css';
import NewEmployeeModalTable from "./NewEmployeeModalTable";
import {getToken} from "../../Utils/Common";

function NewEmployee(props) {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [users, setUsers] = React.useState([])


    useEffect(() => {

        async function fetchBT() {

            let apiBody = {

                "org_id": sessionStorage.getItem("org"),
                "token": getToken()

            }

            return await fetch(`${process.env.REACT_APP_AUTHENTICATION_URI}getalluserdetailformobileApp`, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(apiBody),
            })
                .then((response) => response.json())
                .catch((error) => {
                    console.error('Error:', error);
                })
        }

        fetchBT().then(btData => {

            let adjustedData = []


            adjustedData = btData.allusers.map((item) => {
                return {

                    "id": item.user_id,
                    "firstname": item.user_first_name,
                    "lastname": item.user_last_name,
                    "role":item.user_the_role

                }
            })

            setUsers(adjustedData)
        })

    }, [])


    return (<>
        <Row>
            <Col sm={11}>
                <label className="handwai-text-label-main add-bottom-0-margin">{"Anwesenheit"}</label>
            </Col>
            {!props.originState &&
                <Col sm={1} className="add-flex-end">
                    <Button onClick={handleShow} disabled={props.tstatus==="Akzeptiert"}
                            style={{paddingLeft: 10}}
                            className='handwai-btn-create'>
                        <FontAwesomeIcon icon={faPlus}/></Button>
                </Col>}
        </Row>
        <Modal show={show} onHide={handleClose}
               aria-labelledby="contained-modal-title-vcenter"
               centered>
            <Modal.Header closeButton>
                <Modal.Title>Mitarbeiter Information</Modal.Title>
            </Modal.Header>
            <Modal.Body className="handwai-dark">
                <NewEmployeeModalTable
                    setIsChange={props.setIsChange}
                    employeeDataInfo={props.employeeInfo}
                                       setEmployeeDataInfo={props.setEmployeeInfo}
                                       firstCoworkerEndTime={props.firstCoworkerEndTime}
                                       firstCoworkerStartTime={props.firstCoworkerStartTime}
                                       users={users}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button size='lg' block className='handwai-btn-create'
                        onClick={handleClose}> <FontAwesomeIcon
                    icon={faEraser}/> &emsp;
                    Schließen
                </Button>
            </Modal.Footer>
        </Modal>

    </>);
}

export default NewEmployee;
